import React from 'react';
import TopAgentsList from '../CallCharts/TopAgentsList';
import TopCustomersList from '../CallCharts/TopCustomersList';

export default function CallDrawerContent({ mode, data, filters }) {
  if (!mode) return null;
  if (mode === 'topAgents') return <TopAgentsList data={data} filters={filters} />;
  if (mode === 'topCustomers') return <TopCustomersList data={data} filters={filters} />;
  return null;
}
